import { useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button/Button'
import { Tooltip } from 'core-components/library/tooltip'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import { DeleteDocumentDialog } from '../deleteDocumentDialog/DeleteDocumentDialog'

import styles from './DocumentActions.module.scss'

interface IDocumentActionsProps {
  openHref: string
  documentLabel: string
  canDownload: boolean
  onDownload: () => void
  readOnly: boolean
  canDelete: boolean
  deleteDisabledReason?: string
  onDelete: () => Promise<unknown>
  onDeleted: () => void
  onDeleteError: (e: unknown) => void
}

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks

export const DocumentActions = ({
  openHref,
  documentLabel,
  canDownload,
  onDownload,
  readOnly,
  canDelete,
  deleteDisabledReason,
  onDelete,
  onDeleted,
  onDeleteError,
}: IDocumentActionsProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  return (
    <div className={styles.root}>
      <Button variant="text" size="sm" href={openHref} target="_blank">
        <Translation span text={KEYS.actions.open} />
      </Button>

      <Tooltip
        disabled={canDownload}
        tipContent={() => <Translation span text={KEYS.actions.downloadDisabledTooltip} />}
      >
        <span className={styles.disabledActionTrigger}>
          <Button
            variant="text"
            size="sm"
            iconButton="kbase kbase-download"
            disabled={!canDownload}
            onClick={onDownload}
            title={canDownload ? KEYS.actions.download : undefined}
          />
        </span>
      </Tooltip>

      {!readOnly &&
        (canDelete ? (
          <Button
            variant="text"
            size="sm"
            iconButton="kbase kbase-delete"
            onClick={() => setShowDeleteDialog(true)}
            title={KEYS.actions.delete}
          />
        ) : (
          <Tooltip
            tipContent={() => (
              <Translation span text={deleteDisabledReason ?? KEYS.actions.deleteDisabledTooltip} />
            )}
          >
            <span className={styles.disabledActionTrigger}>
              <Button variant="text" size="sm" iconButton="kbase kbase-delete" disabled />
            </span>
          </Tooltip>
        ))}

      {!readOnly && (
        <DeleteDocumentDialog
          show={showDeleteDialog}
          documentLabel={documentLabel}
          onConfirm={onDelete}
          onDeleted={onDeleted}
          onError={onDeleteError}
          closeDialog={() => setShowDeleteDialog(false)}
        />
      )}
    </div>
  )
}

DocumentActions.displayName = 'DocumentActions'
